<template>
  <div class="menuPage-main">
    <!-- 菜单 -->
    <ul class="menu_Ul">
    
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.menuPage-main {
  
}
</style>